import { Box } from '@hopskipdrive/react-components';
import styled from 'styled-components';

import { colorTokens } from '../../shared/components/variables';

export const PageHeading = styled(Box)`
  background-color: ${colorTokens.tonal.light};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 9px 12px;
  border-bottom: 1px solid ${colorTokens.border.main};
`;

export const PageContent = styled(Box)`
  padding: 12px;

  & > * {
    margin-top: 12px;

    &:first-child {
      margin-top: 0;
    }
  }
`;
